export default __webpack_public_path__ + "static/media/haatBazar.04c33e24.png";